module.exports = __webpack_public_path__ + "static/media/current-location.5dcf94a0.png";